import './style.scss';
import { getDocuments } from '../utils';
import switchDown from '../../../assets/svg/switch-down.svg';
import {
  IProjectDocInfo,
  IProjectDocInfoMenu,
} from '../../../model/api-modules/document';

interface IProps {
  readonly currentDocument: IProjectDocInfoMenu | undefined;
  readonly projectDocInfo: IProjectDocInfo | undefined;
  readonly joinPath: (
    projectId: string | number,
    docId?: string | number
  ) => void;
  readonly setSelectActive: (value: ReadonlyArray<number>) => void;
}

export const DocumentSwitch = (props: IProps) => {
  const document = getDocuments(props.projectDocInfo?.menu);
  const currentId = props.currentDocument?.id;
  const currentItem = document.filter(
    (item: IProjectDocInfoMenu) => item.id === currentId
  )[0];
  const currentIndex = document.indexOf(currentItem);
  const switchUpItem = document[currentIndex - 1];
  const switchDownItem = document[currentIndex + 1];

  return (
    <div className="document-switch">
      <div>
        {switchUpItem && (
          <span
            onClick={() => {
              props.joinPath(switchUpItem.project_id, switchUpItem.id);
              props.setSelectActive([switchUpItem.id]);
            }}
          >
            <img
              src={switchDown}
              style={{ transform: 'rotate(180deg)', marginRight: '8px' }}
            />
            {switchUpItem.name}
          </span>
        )}
      </div>
      <div>
        {switchDownItem && (
          <span
            onClick={() => {
              props.joinPath(switchDownItem.project_id, switchDownItem.id);
              props.setSelectActive([switchDownItem.id]);
            }}
          >
            {switchDownItem.name}
            <img src={switchDown} style={{ marginLeft: '8px' }} />
          </span>
        )}
      </div>
    </div>
  );
};
